import React from 'react'
import { Menu, Icon } from 'semantic-ui-react'

const Pagination = ({ paging }) => {
  if (!paging) return null
  return (
    <Menu floated="right" pagination>
      {paging.map((item, i) => {
        if (item.first) {
          return (
            <Menu.Item as="a" key={i} onClick={item.onClick} icon>
              <Icon name="chevron left" />
            </Menu.Item>
          )
        } else if (item.last) {
          return (
            <Menu.Item as="a" key={i} onClick={item.onClick} icon>
              <Icon name="chevron right" />
            </Menu.Item>
          )
        }
        return (
          <Menu.Item
            as="a"
            key={i}
            disabled={item.disabled}
            active={item.active}
            onClick={item.onClick}
          >{item.text}</Menu.Item>
        )
      })}
    </Menu>
  )
}

Pagination.propTypes = {
  paging: React.PropTypes.array,
  colSpan: React.PropTypes.number,
}

export default Pagination



// WEBPACK FOOTER //
// ./src/browser/components/Pagination.js